import React from 'react';

export default function About() {
	return (
		<div>
			<header>
				<h1>About</h1>
			</header>
		</div>
	);
}
